// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__WVRO9","total":"Cart_total__ldEf9","actions":"Cart_actions__AsK2u","button--alt":"Cart_button--alt__iSPuT","button":"Cart_button__Z0qQP"};